import PropTypes from 'prop-types';
import get from 'lodash/get';
import ClampText from 'src/common/components/shared/ClampText';
import { isMedium } from 'src/common/utils/breakpoints';
import GridMatrixLayout from 'src/common/decorators/containerItems/GridMatrixLayout';
import PlayButton from '../../containerItems/shared/PlayButton';
import GuideItemLink from '../shared/GuideItemLink';
import GuideItemTitle from '../shared/GuideItemTitle';
import css from './numbered-link.module.scss';

export const NumberedItemLink = ({ guideItem, index }) => {
  const title = get(guideItem, 'properties.seoInfo.title');

  return (
    <div
      className={css.numberedLinkContainer}
      data-testid={`guideItem-${index}`}
      data-testtype="numberedLink"
      data-nexttitle={title}
      data-nextguideitem={guideItem.guideId}
    >
      <GuideItemLink
        dataTestId="guideItemNumberLink"
        guideItem={guideItem}
        className={css.listNumberContainer}
      >
        <div className={css.listNumber} data-testid="guideItemNumber">
          {guideItem.index}
        </div>
      </GuideItemLink>
      <div className={css.numberedLinkImageContainer}>
        <PlayButton guideItem={guideItem}>
          <img
            data-testid="guideItemImage"
            src={guideItem.image}
            alt={guideItem.title}
          />
        </PlayButton>
      </div>
      <div className={css.infoContainerWrapper}>
        <GuideItemTitle
          dataTestId="guideItemTitleLink"
          guideItem={guideItem}
          hasOwnTitleWrapper
          hasImage
        >
          <h2 data-testid="guideItemTitle" className={css.headerText}>
            {guideItem.title}
          </h2>
          <ClampText
            clamp={2}
            className={css.descriptionText}
            truncationHTML={'<span>...</span>'}
            useNativeClamp={false}
          >
            <div data-testid="guideItemDescription">
              {guideItem.description}
            </div>
          </ClampText>
        </GuideItemTitle>
      </div>
    </div>
  );
};

NumberedItemLink.propTypes = {
  guideItem: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export function numberedMatrixGetNumberOfColumns(breakpoint) {
  if (isMedium(breakpoint)) return 2;
  return 1;
}

function NumberedLinkWithMatrixLayout(props) {
  return (
    <GridMatrixLayout
      ChildPresentation={NumberedItemLink}
      getNumberOfColumns={numberedMatrixGetNumberOfColumns}
      dataTestType="numberedListPresentation"
      {...props}
    />
  );
}

export default NumberedLinkWithMatrixLayout;
